import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { OverviewView } from '@/features/clients/OverviewView'

function OverviewRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <OverviewView companyId={companyId} />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/clients/$companyId/overview')({ component: OverviewRoute })
